import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { EmrIntegrationState } from './types';

type EmrIntegrationActions = {
  setIsInProgress: (isInProgress: boolean) => void;
  updateIntegrationProgress: (
    process?: EmrIntegrationState['integrationProcess']
  ) => void;
};

const initialState: EmrIntegrationState = {
  isInProgress: false,
};

export const useEmrIntegrationStore = create<
  EmrIntegrationState & EmrIntegrationActions
>()(
  immer((set) => ({
    ...initialState,
    setIsInProgress: (isInProgress) => {
      set((state) => {
        state.isInProgress = isInProgress;
      });
    },
    updateIntegrationProgress: (process) => {
      set((state) => {
        if (!process || process.progress === 100) {
          state.integrationProcess = undefined;
          state.isInProgress = false;
          return;
        }
        state.isInProgress = true;
        state.integrationProcess = process;
      });
    },
  }))
);
